export const ImageDefault =
  'https://firebasestorage.googleapis.com/v0/b/crm-jackpots.appspot.com/o/jp-dev%2Fwidgets%2Fproduct-desktop.svg?alt=media&token=e801f3d7-6ecc-40a2-8708-6802ad9ade82'

export const JPDefaultBoosterImage =
  'https://firebasestorage.googleapis.com/v0/b/media-db-jp-prod/o/jackpots-production%2FBoosters%20%26%20Bonuses%2Fbooster-item.png?alt=media&token=4d1475ec-d4f2-41ba-a0ce-685e8732a0c6'

export const assetsRouteDevelop = 'http://localhost:3000/'
